import adminModuleActions from "./cardModule/actions";

export default {
  ...adminModuleActions,
};
